module.exports = __webpack_public_path__ + "img/Error_Page_Image.2921b302.svg";